import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth'; 
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosInstance';
import './AccountConfirmation.css';

const AccountConfirmation = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [confirmationStatus, setConfirmationStatus] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const { setIsAuthenticated } = useAuth();

    useEffect(() => {
        const confirmAccount = async () => {
            if (!token) {
                setConfirmationStatus('Invalid confirmation link. Please request a new confirmation email.');
                setIsLoading(false);
                return;
            }

            try {
                console.log('Attempting to confirm account with token:', token);
                const response = await axiosInstance.post('/users/confirm', { token });
                console.log('Confirmation response:', response.data);

                // Check if the response indicates success, even without a token
                if (response.data.success || response.data.message?.includes('confirmed')) {
                    setConfirmationStatus('Account successfully confirmed!');
                    setIsConfirmed(true);
                    // Only set token and authentication if it's provided
                    if (response.data.token) {
                        localStorage.setItem('token', response.data.token);
                        setIsAuthenticated(true);
                    }
                } else if (response.data.message) {
                    // If there's a message but no success flag, show the message
                    setConfirmationStatus(response.data.message);
                } else {
                    // If we get here, something unexpected happened
                    console.warn('Unexpected response format:', response.data);
                    setConfirmationStatus('Account confirmation successful!');
                    setIsConfirmed(true);
                }
            } catch (error) {
                console.error('Full error object:', error);
                console.error('Error response:', error.response?.data);
                console.error('Error status:', error.response?.status);

                // Check if the error is due to already confirmed account
                if (error.response?.status === 400 && 
                    (error.response?.data?.message?.includes('already confirmed') || 
                     error.response?.data?.message?.includes('already exists'))) {
                    setConfirmationStatus('Your account is already confirmed.');
                    setIsConfirmed(true);
                } else if (error.response?.status === 200) {
                    // Sometimes the backend might return 200 but the response is in error format
                    setConfirmationStatus('Account confirmation successful!');
                    setIsConfirmed(true);
                } else {
                    setConfirmationStatus('Error confirming account. Please try again or contact support.');
                }
            } finally {
                setIsLoading(false);
            }
        };

        confirmAccount();
    }, [token, setIsAuthenticated]);

    const handleGoToProfile = () => {
        navigate('/Profile');
    };

    return (
        <div className="account-confirmation-container">
            <div className="confirmation-card">
                <h2>Account Confirmation</h2>
                {isLoading ? (
                    <div className="loading-spinner">
                        <div className="spinner"></div>
                        <p>Confirming your account...</p>
                    </div>
                ) : (
                    <>
                        <p className={`status-message ${confirmationStatus.includes('successfully') || confirmationStatus.includes('already confirmed') ? 'success' : 'error'}`}>
                            {confirmationStatus}
                        </p>
                        {isConfirmed && (
                            <button 
                                className="go-to-profile-button"
                                onClick={handleGoToProfile}
                            >
                                Go to Your Profile
                            </button>
                        )}
                        {confirmationStatus.includes('Error') && !confirmationStatus.includes('already confirmed') && (
                            <button 
                                className="retry-button"
                                onClick={() => window.location.reload()}
                            >
                                Try Again
                            </button>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default AccountConfirmation;
